// extracted by mini-css-extract-plugin
export default {"body":"main_body__9NCFO","boldNumber":"main_boldNumber__LL1u-"};